// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.module-container {
  max-width: 1200px; /* Ajuste la largeur selon tes besoins */
  margin: 0 auto; /* Centre horizontalement */
  padding: 20px; /* Ajoute un peu d'espace autour */
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ManageModules/ManageModule.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAE,wCAAwC;EAC3D,cAAc,EAAE,2BAA2B;EAC3C,aAAa,EAAE,kCAAkC;EACjD,gBAAgB;AAClB","sourcesContent":[".module-container {\n  max-width: 1200px; /* Ajuste la largeur selon tes besoins */\n  margin: 0 auto; /* Centre horizontalement */\n  padding: 20px; /* Ajoute un peu d'espace autour */\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
